import { render, staticRenderFns } from "./RV3.vue?vue&type=template&id=972af868&"
import script from "./RV3.vue?vue&type=script&lang=js&"
export * from "./RV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/github_repos/Ribovision_2.0_GT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972af868')) {
      api.createRecord('972af868', component.options)
    } else {
      api.reload('972af868', component.options)
    }
    module.hot.accept("./RV3.vue?vue&type=template&id=972af868&", function () {
      api.rerender('972af868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/RV3.vue"
export default component.exports